import { useHomeData } from '@/hooks/useHomeData';

interface CopyrightProps {
  showSeparator?: boolean;
  className?: string;
}

export function Copyright({ showSeparator = false, className = '' }: CopyrightProps) {
  const { homeData } = useHomeData();

  return (
    <div className={`text-center ${className}`}>
      {showSeparator && <div className="h-0.5 w-40 bg-gray-400 mx-auto mb-4"></div>}
      <p className="text-sm text-foreground/60">
        Copyright © {new Date().getFullYear()} {homeData.footer.companyName}
        <br />
        <span className="text-xs">{homeData.footer.copyright}</span>
      </p>
      <p className="text-xs text-foreground/40 mt-2">
        Website by{' '}
        <a href="https://siteforward.ai/aviation" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors underline">
          SiteForward
        </a>
      </p>
    </div>
  );
}